export default __webpack_public_path__ + "static/media/Somalia.da9b6bb8.png";